import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { CreativeTagGenerator } from './CreativeTagGenerator';
//import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter, Switch, Route, NavLink } from 'react-router-dom';
import { convertToAdUnits } from './utils';
import { adUnits } from './components/adSpotGrops/config';

const Main = () => {
    const data = new URL(window.location.href).searchParams.get('data') || '{}';

    const { it = 2, adverts = [] } = JSON.parse(data);
    const activeTab = ['', 'DIRECT', 'DFP', 'SAFE FRAME'][it];
    const convertedAdUnits = adverts.reduce(convertToAdUnits, {});
    const newAdUnits = Object.fromEntries(
        Object.entries(adUnits).map(([name, value]) => {
            return !convertedAdUnits[name]
                ? [name, value]
                : [name, { ...value, ...convertedAdUnits[name], selected: true }];
        }),
    );

    return (
        <BrowserRouter>
            <Switch>
                <Route path="/creative" render={(props) => <CreativeTagGenerator />} />
                <Route path="/" render={(props) => <App adUnits={newAdUnits} activeTab={activeTab} />} />
                <Route path="*" render={(props) => <App adUnits={newAdUnits} activeTab={activeTab} />} />
            </Switch>
        </BrowserRouter>
    );
};
ReactDOM.render(<Main />, document.getElementById('root'));
//registerServiceWorker();
